
import { useState } from "react";
import shoesdata from "./ShoesApi";
import ShoesCard from "./ShoesCard";
import Navigation from "./Navigation";
function Shoes() {
    let [data, setData] = useState(shoesdata);

     function find(catagary1){
        if(catagary1 == "All"){
            setData(shoesdata);
            return;
        }

        let navlist = shoesdata.filter((apidata)=>{
            return apidata.catagary === catagary1;
        })

        setData(navlist);
     }
     let uniqlist = [...new Set(shoesdata.map((list)=>
     {
        return list.catagary;
     })),"All"]
       let [nevigationlist,setNavigationList] = useState(uniqlist);

    return (
        <>
            <Navigation find = {find} nevigationlist = {nevigationlist}/>
            <ShoesCard item={data} />

        </>
    )
}

export default Shoes;